

















































































































































import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import ScrollView from '@/components/ScrollView.vue'
import Icon from '@/components/Icon.vue'
import { Watch } from 'vue-property-decorator'
import { EClaimStatus, ITransactionEffectiveDate } from '@zunta/configurations'
import Modal from '@/components/Modal.vue'
import CollectionsLineItemsModal from '@/views/app/management/collections/components/CollectionsLineItemsModal.vue'
import { TransactionsModule } from '@/store/modules/transactions.module'
import { waitUntil } from '../../../../../utils/helpers'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import CollectionSharedFunctions from '../CollectionSharedFunctions'
import NoRows from '@/components/tables/NoRows.vue'

@Component({
  props: {
    withClaim: {
      type: Boolean,
      default: false
    },
    claimTask: {
      type: Object
    },
    residentId: {
      type: Number,
      required: true
    }
  },
  components: { NoRows, LoaderWrapper, CollectionsLineItemsModal, Modal, Icon, ScrollView }
})
export default class CollectionAgingView extends CollectionSharedFunctions {
  transactionModuleInstance: TransactionsModule = getModule(TransactionsModule, this.$store);
  elementWidth: number = 110
  amountOfElementsToDisplay: number = 0
  currentFirstItemIndex: number = 0

  bgColWidth: number = 132

  selectedTED: any = {
    remainingAmount: 0,
    billedAmount: 0,
    paidAmount: 0
  }

  showLineItemsModal: boolean = false
  isLoading: boolean = false

  get transactionLineItems () {
    return this.$store.state.transactions.transactionLineItems
  }

  get isPrev () {
    return this.currentFirstItemIndex - 1 >= 0
  }

  get isNext () {
    if (!this.agingTEDS) {
      return false
    }
    return this.currentFirstItemIndex < this.agingTEDS.length - this.amountOfElementsToDisplay
  }

  get agingList () {
    return this.transactionModuleInstance.aging.data
  }

  get agingPayers () {
    return this.transactionModuleInstance.aging.payerTypesMap
  }

  get agingTEDS () {
    return this.transactionsModuleInstance.aging && this.transactionsModuleInstance.aging.transactionEffectiveDates
      ? this.transactionsModuleInstance.aging.transactionEffectiveDates
      : []
  }

  get grandTotal () {
    return Object.values(this.agingPayers).reduce((sum: number, payer: any) => sum + payer.payerTotal, 0)
  }

  get list () {
    if (!this.agingTEDS || !this.agingTEDS.length) {
      return []
    }
    return this.agingTEDS.slice(this.currentFirstItemIndex, this.amountOfElementsToDisplay + this.currentFirstItemIndex)
  }

  async mounted () {
    window.addEventListener('resize', this.setAmountOfElementsToDisplay)
    this.$eventBus.$on('resize', this.setAmountOfElementsToDisplay)
    this.fetchData()
    if (this.$props.claimTask) {
      await waitUntil(() => {
        return this.list.length > 0
      }, 2000)
      this.moveToTaskTed()
    }
  }

  moveToTaskTed (maxCount: number = 15) {
    if (maxCount === 0) {
      return
    }
    const ted = this.list.find((effectiveDate: string) => {
      const items = this.transactionModuleInstance.aging.data[effectiveDate]
      return Object.keys(items).find(key => {
        return items[key].id === this.$props.claimTask.transactionEffectiveDate.id
      })
    })
    if (!ted) {
      this.currentFirstItemIndex++
      this.$nextTick(() => {
       this.moveToTaskTed(maxCount - 1)
      })
    }
    // this.$watch('residentId', () => this.fetchData())
  }

  async fetchData () {
    try {
      this.isLoading = true
      await this.transactionModuleInstance.getAging(this.residentId || this.$props.residentId)
    } finally {
      this.isLoading = false
    }
  }

  destroyed () {
    window.removeEventListener('resize', this.setAmountOfElementsToDisplay)
    this.$eventBus.$off('resize', this.setAmountOfElementsToDisplay)
  }

  toggleLineItemsModal (value: boolean) {
    this.showLineItemsModal = value
  }

  updateShownAgingList (index: number = 0) {
    this.currentFirstItemIndex = index
  }

  getClaimClass (status?: EClaimStatus) {
    if (!status) {
      return ''
    }
    switch (status) {
      case EClaimStatus.PAID:
        return 'success'
      case EClaimStatus.NO_CLAIM:
      case EClaimStatus.ERROR:
      case EClaimStatus.NA:
      case EClaimStatus.AWAITING:
      case EClaimStatus.NOT_REGISTERED:
      case EClaimStatus.PENDING:
        return 'pending'
      case EClaimStatus.DENIED:
        return 'danger'
      default:
        return ''
    }
  }

  hasClaims (agingData: any) {
    return agingData && agingData['claimCount'] > 0
  }

  async getTEDLineItems (value: any) {
    await this.transactionModuleInstance.getAgingDetails(value.id)
    this.selectedTED = value
    this.selectedTED.claim = this.transactionModuleInstance.agingDetails.claim
    this.selectedTED.tasks = this.transactionModuleInstance.agingDetails.tasks
    this.toggleLineItemsModal(true)
  }

  @Watch('agingList', { deep: true, immediate: true })
  setAmountOfElementsToDisplay () {
    this.$nextTick(() => {
      const $table: HTMLElement | null = document.getElementById('agingTable')
      if (!$table) {
        return
      }
      const tableWidth = $table.offsetWidth
      const elementWidth = 132
      this.amountOfElementsToDisplay = Math.floor((tableWidth) / elementWidth)
      this.bgColWidth = tableWidth
      this.updateShownAgingList()
    })
  }

  scrollPrev () {
    if (!this.isPrev) {
      return
    }
    this.updateShownAgingList(this.currentFirstItemIndex - 1)
  }

  scrollNext () {
    if (!this.isNext) {
      return
    }
    this.updateShownAgingList(this.currentFirstItemIndex + 1)
  }
}
